module.exports = __webpack_public_path__ + "static/media/9.4f10bc4b.webp";